import { useState } from 'react'
import { getMobileOS, MobileOS } from '@/common/utils/getMobileOS'

export function useMobileOS(): MobileOS {
    const [os] = useState<MobileOS>(() => getMobileOS())
    return os
}
